
<template>
  <b-container fluid>
    <b-row class="text-center">
      <b-col cols="6">
        <img :src="imageQr" alt="qr" v-if="qr !== null" :style="`margin-top: ${qrMarginTop}`"/>
        <p v-else>Cargando...</p>
        <b-alert :variant="resultValidationType"
               dismissible
               :show="showResultValidation"
               @dismissed="showResultValidation=false"
               class="mt-2">
        <h4 class="alert-heading" v-if="resultValidationType === 'success'">{{ session.language.allowed }}!</h4>
        <h4 class="alert-heading" v-else>{{ session.language.denied }}!</h4>
        <p v-if="wsError === null">
          <strong>Punto de control: </strong>{{ pass.checkpointName }} <strong>Visitante: </strong>{{ pass.visitorName }} <strong>Placa: </strong>{{ pass.visitorPlate }} <strong>Departamento: </strong>{{ pass.apartment }} <strong>Edificio: </strong>{{ pass.building }}
        </p>
        <p v-else>
          {{ wsError }}
        </p>
        <div class="row">
          <div class="col-6">
            <small>
              <strong>Tipo de validación: </strong>
              <span v-if="pass.offline">Offline</span>
              <span v-else>Online</span>
            </small>
          </div>
          <div class="col-6 text-right">
            <small>
              <strong>{{ pass.validationDate }}</strong>
            </small>
          </div>
        </div>
      </b-alert>
      </b-col>
      <b-col cols="6">
        <b-row>
          <div class="col-md-6 mt-5">
            <b-img center src="/img/qr_image.gif" fluid alt="qr"></b-img>
            <form>
              <div class="form-group mt-3">
                <label for="qr"><strong>Código QR</strong></label>
                <textarea
                    ref="qrCodeInput"
                    class="form-control"
                    id="qr"
                    @input="validate"
                    v-model="qrCode"
                    :disabled="busy"
                ></textarea>
              </div>
            </form>
          </div>
        </b-row>
      </b-col>
      <div id="lock-passport-window" v-if="lockPassport && locked">
        <div class="lock-passport-content" :style="`margin-top: ${qrMarginTop}`">
          <p>{{ unlockText }}</p>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  import io from 'socket.io-client'
  import Config from '../config/app.json'
  import { check } from '@/services/apiLocalService'
  import { mapActions } from 'vuex'
  import debounce from 'debounce'

  export default {
    name: 'Hybrid',
    data () {
      return {
        qr: null,
        qrCode: null,
        locked: true,
        busy: false,
        showResultValidation: false,
        resultValidationType: 'success',
        wsError: null,
        lastValidatedCards: [],
        pass: {
          checkpointName: null,
          visitorName: null,
          visitorPlate: null,
          apartment: null,
          building: null,
          offline: false,
          date: null
        }
      }
    },
    created () {
      this.listenSocketEvents()
      this.listenWebSocketEvents()
      this.resetInput()
    },
    methods: {
      listenWebSocketEvents () {
        const socket = io(`${Config.socketUrl}`)
        socket.on('checkResult', data => {
          if (!data.success) {
            this.showResultValidation = true
            this.resultValidationType = 'danger'
            this.wsError = data.error
            this.resetInput()
            return
          }

          this.pass.apartment = data.fastPass.apartment
          this.pass.building = data.fastPass.building
          this.pass.visitorName = data.fastPass.visitor.name
          this.pass.visitorPlate = data.fastPass.visitor.licensePlate
          this.pass.checkpointName = data.checkpoint.name
          this.pass.offline = data.fastPass.offline

          this.showResultValidation = true
          this.resultValidationType = 'success'

          this.resetInput()
        })
      },
      listenSocketEvents () {
        const socket = io(`${Config.socketUrl}`)

        this._listenUpdateQr(socket)

        if (!this.lockPassport) {
          return
        }

        this._listenLockPassport(socket)
      },
      _listenUpdateQr (socket) {
        socket.on('updateQr', data => {
          this.qr = data.qr
        })
      },
      _listenLockPassport (socket) {
        socket.on('unlockPassport', () => {
          if (!this.locked) {
            return
          }

          this.locked = false

          setTimeout(() => {
            this.locked = true
          }, Config.lockPassportTime)
        })
      },
      ...mapActions([
        'setSession'
      ]),
      validate: debounce(function () {
        if (this.busy) {
          this.resetInput()
          return
        }

        this.checkFastPass()
      }, 2000),
      async checkFastPass () {
        let data = null
        this.busy = true
        try {
          data = JSON.parse(this.qrCode)
          if (!data) {
            throw new Error('Invalid input')
          }

          if (!Object.keys(data).length) {
            this.resetInput()
            return
          }

          const result = await check(data, this.$route.params.checkPointId)

          this.resetInput()

          if (result.type === 'success') {
            this.displayValidationResponse(result.checkResult, result.type)
            return
          }

          this.displayValidationResponse({}, 'danger')
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err)
          this.resetInput()
        }
      },
      displayValidationResponse (data, type) {
        const cards = data.cards || []
        const visitorCard = cards.find(c => c.type === 'visitor')
        const generalCard = cards.find(c => c.type === 'general')
        this.pass.offline = data.offline
        this.pass.validationDate = data.validationDate

        this.showResultValidation = true
        this.resultValidationType = type
        if (visitorCard !== undefined) {
          this.pass.visitorName = visitorCard.name
          this.pass.visitorPlate = visitorCard.licensePlate
        }

        if (visitorCard !== undefined) {
          this.pass.apartment = generalCard.apartment
          this.pass.building = generalCard.building
        }
        this.resetInput()
      },
      resetInput () {
        this.qrCode = ''
        this.busy = false
        this.$nextTick(() => {
          if (this.$refs.qrCodeInput) {
            this.$refs.qrCodeInput.focus()
          }
        })
      },
    },
    computed: {
      imageQr () {
        return this.qr
      },
      session () {
        return this.$store.getters.session || { user: { email: null, token: null }, language: {} }
      },
      qrMarginTop () {
        return Config.qrMarginTop
      },
      unlockText () {
        return Config.lockPassportText
      },
      lockPassport () {
        return Config.lockPassport || false
      }
    }
  }
</script>

<style>
@import '../assets/css/passport.css';
</style>
